<na-cert-pickup [supportChooseCertAction]="false" [supportRefreshCert]="true"></na-cert-pickup>